import request from '../request'
/**
 *  获取所有的权限
 * @method getAllPermission
 * @return {[type]}         [description]
 */

//根据一级查询2，3级code
export function findByTopCode(form) {
    return request({
        url: `web/sys-dictionary/front/findByTopCode`,
        method: 'get',
        params: form,
    })
}

//新闻配置code查询
export function newCodeDic() {
    return request({
        url: `web/sys-dictionary/front/newCodeDic`,
        method: 'get',
    })
}

//查询首页显示字典
export function newsDic() {
    return request({
        url: `web/sys-dictionary/front/newsDic`,
        method: 'get',
    })
}
//查询类型配置
export function typeDic() {
    return request({
        url: `web/sys-dictionary/front/typeDic`,
        method: 'get',
    })
}
//修改或新增字典
export function sysDictionary(form) {
    return request({
        url: `web/sys-dictionary/system`,
        method: 'post',
        data: form,
    })
}

//根据父级结构查询
export function searchDictionary(form) {
    return request({
        url: `web/sys-dictionary/system/listByParentCode`,
        method: 'get',
        params: form
    })
}

//删除字典
export function delDictionary(form) {
    return request({
        url: `web/sys-dictionary/system/` + form,
        method: 'delete',
    })
}